export type TeamManagementItemData = {};

export type TeamManagementPagination = {
  "@id": string;
  type: string;
  first: string;
  last: string;
  previous: string;
  next: string;
};

export type TeamManagementSearchMappingItem = {
  "@type": string;
  variable: string;
  property: string;
  required: boolean;
};

export type TeamManagementSearch = {
  "@type": string;
  template: string;
  variableRepresentation: string;
  mapping: TeamManagementSearchMappingItem[];
};

export type TeamManagementListResponse = {
  member: TeamManagementItemData[];
  totalItems: number;
  view: TeamManagementPagination;
  search: TeamManagementSearch;
};

export type TeamManagementPageState = {
  page: number;
  itemsPerPage?: number;
  pagination?: boolean;
  name?: string | null;
  address?: string | null;
  reference?: string | null;
  q?: string | null;
  order?: { dataKey: string; order?: "asc" | "desc" };
};

export type TeamManagementListStateType = {
  pageState: TeamManagementPageState;
  setPageState: (state: TeamManagementPageState) => void;
  resetPageState: () => void;
};

export const initialTeamManagementPageState: TeamManagementPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
  // order: { dataKey: "id", order: "desc" },
};
